import styled from 'styled-components';

import { spaceL, spaceXL, spaceXXL } from '@xing-com/tokens';
import { Headline as InnerHeadline } from '@xing-com/typography';

import { FollowButton as InnerFollowButton } from '../follow-button';

export const Headline = styled(InnerHeadline)<$TSFixMe>`
  margin: ${spaceXL} 0 ${spaceL} 0;
  &.industry-company-headline {
    margin: ${spaceXL} 0 ${spaceXXL} 0;
  }
`;

export const FollowButton = styled(InnerFollowButton)`
  margin-left: auto;
`;
